import Image from "next/image";
import Link from "next/link";

const HealthcareBannerMobile = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = 0;
    if (window.innerWidth <= 768) {
      // Mobile version
      yOffset = -130;
    } else {
      // Desktop version
      yOffset = -150;
    }

    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="w-full bg-white">
        <div className="mx-auto w-full 2xl:h-[700px] md:h-[95vh] h-[auto] xl:px-0 md:px-6 lg:!px-6  px-0 relative md:bg-bottom bg-center square_grid_bg bg-inherit bg-repeat md:bg-cover bg-auto bg-[length:100% 100%] md:pb-0 pb-[40px]">
          <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative">
            <div className="flex justify-between flex-wrap 2xl:items-center items-center 2xl:h-[650px] md:h-[65vh] h-auto">
              <Image
                src="/healthcare/single-star.png"
                alt="CPA Recruiting firms"
                className="absolute left-[16%] bottom-[60%]"
                width={17}
                height={17}
              />
              <div className="md:pt-5 pt-[240px] pb-[00px] w-full md:pb-16 relative 2xl:top-[50px] md:top-[120px] mt-0 md:ml-[70px]">
                <div className="text-center relative">
                  <h1 className="font-bold text-[24px] text-[#202852] mt-2 leading-[1.3]">
                    Addressing the{" "}
                    <span className="text-[#008D82]">Healthcare</span> <br />{" "}
                    Talent Shortage in the US
                  </h1>

                  <div className="flex flex-row md:flex-row justify-center items-center gap-4 md:gap-8 mt-7">
                    <Link
                      href={"/healthcare/nursing"}
                      className="flex items-center justify-between  border-[2px] border-[#FFA548] rounded-[14px] bg-white px-5 py-2 font-semibold text-[16px] md:text-[16px] xl:text-[20px] 2xl:text-[22px] hover:border-blue-500 transition-colors"
                    >
                      <span>Nurses</span>
                      {/* <HiOutlineArrowRight className="ml-2" /> */}
                    </Link>

                    <Link
                      href={"/mbbs"}
                      className="flex items-center justify-between border-[2px] border-[#FFA548] rounded-[14px] bg-white px-5 py-2 font-semibold text-[16px] md:text-[16px] xl:text-[20px] 2xl:text-[22px] hover:border-blue-500 transition-colors"
                    >
                      <span>Doctors</span>
                    </Link>
                  </div>
                  <div className="text-center mx-auto md:mt-12 mt-6 md:hidden block">
                    <div className=" flex justify-center">
                      <div
                        className="grp_btn justify-center font-medium items-center !px-8 py-2 text-[13px] !bg-[#3174d6] text-white rounded-[8px] relative inline"
                        onClick={() => scrollToSection("crim")}
                      >
                        <span className="">Discover Programs</span>
                        <Image
                          src="/healthcare/home/str.svg"
                          alt="CPA Recruiting firms"
                          className="absolute -left-5 bottom-0"
                          width={12}
                          height={12}
                        />
                        <Image
                          src="/healthcare/home/str.svg"
                          alt="CPA Recruiting firms"
                          className="absolute -right-4 top-0 rotate-180 scale-x-[-1]"
                          width={12}
                          height={12}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="md:hidden bg-white flex w-[349px] mx-auto h-[70px] justify-between items-center gap-2.5 shrink-0 border shadow-[4px_4px_8px_0px_rgba(4,84,175,0.25)] px-4 py-2 mt-5 rounded-lg border-solid border-[rgba(51,153,255,0.20)]">
                    <div>
                      <p className="text-[#202852] text-center text-[20px] not-italic font-semibold leading-[23px] tracking-[-0.64px]">
                        70K+
                      </p>
                      <p className="text-[#202852] text-center text-[10px] not-italic font-medium leading-[11px] tracking-[-0.36px]">
                        Global
                        <br /> Alumni Base
                      </p>
                    </div>
                    <div className="white_divider"></div>
                    <div>
                      <p className="text-[#202852] text-center text-[20px] not-italic font-semibold leading-[23px] tracking-[-0.64px]">
                        300+
                      </p>
                      <p className="text-[#202852] text-center text-[10px] not-italic font-medium leading-[11px] tracking-[-0.36px]">
                        MNC’c & Corporate
                        <br /> Partnerships
                      </p>
                    </div>
                    <div className="white_divider"></div>
                    <div>
                      <p className="text-[#202852] text-center text-[20px] not-italic font-semibold leading-[23px] tracking-[-0.64px]">
                        100K+
                      </p>
                      <p className="text-[#202852] text-center text-[10px] not-italic font-medium leading-[11px] tracking-[-0.36px]">
                        University
                        <br /> Tie-ups
                      </p>
                    </div>
                    <div className="white_divider"></div>
                    <div>
                      <p className="text-[#202852] text-center text-[20px] not-italic font-semibold leading-[23px] tracking-[-0.64px]">
                        50K+
                      </p>
                      <p className="text-[#202852] text-center text-[10px] not-italic font-medium leading-[11px] tracking-[-0.36px]">
                        Global Training
                        <br /> Centers
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Image
            src="/healthcare/healthBan-mob.png"
            alt="accounting jobs in usa"
            className="absolute top-0 bottom-0 right-0 left-0 md:hidden block w-full "
            width={400}
            height={300}
          />
        </div>
      </div>
    </>
  );
};
export default HealthcareBannerMobile;
